export const VOICE_OTP_LOGS_INDEX_REQUEST = "VOICE_OTP_LOGS_INDEX_REQUEST";
export const VOICE_OTP_LOGS_INDEX_SUCCESS = "VOICE_OTP_LOGS_INDEX_SUCCESS";
export const VOICE_OTP_LOGS_INDEX_ERROR = "VOICE_OTP_LOGS_INDEX_ERROR";
